import React from 'react'
import * as utils from '../components/common/utils'
import styles from './Footer.module.scss'
// components
import Sunny from '../images/svg/icon_sunny.svg'
import ArrowUp from '../images/svg/icon_arrow-up.svg'

const Footer = ({ siteTitle }) => (
    <footer className={styles.wrapper}>
        <div className={styles.container}>
            <nav className={styles.nav}>
                <div 
                    className={styles.navItem} 
                    onClick={() => utils.moveto("news")}
                >News</div>
                <div 
                    className={styles.navItem} 
                    onClick={() => utils.moveto("concept")}
                >Concept</div>
                <div 
                    className={styles.navItem} 
                    onClick={() => utils.moveto("works")}
                >Works</div>
                <div 
                    className={styles.navItem} 
                    onClick={() => utils.moveto("services")}
                >Services</div>
                <div 
                    className={styles.navItem} 
                    onClick={() => utils.moveto("about")}
                >About</div>                                             
                <a className={styles.navItem} href="mailto: info@happysunny.net">Contact us</a>
            </nav>
            <div className={styles.copyright}>
                <span>© {new Date().getFullYear()} {siteTitle}</span>
            </div>
            <div 
                className={styles.pagetop}
                onClick={() => utils.moveto('top')}
            >
                <div className={styles.pagetopInner}>
                    <Sunny />
                    <ArrowUp />
                </div>
                Pagetop
            </div>            
        </div>

    </footer>
)

export default Footer
